'use client';

import { useWorkspace } from '@/contexts/useWorkspace';

import { MainDialog } from './mainDialog';

export function SharedMainDialog() {
  const { sharedDialog } = useWorkspace();

  const currentDialog =
    sharedDialog.stack.length > 0
      ? sharedDialog.stack[sharedDialog.stack.length - 1]
      : null;

  const hasBackHistory = sharedDialog.stack.length > 1;

  if (!currentDialog) {
    return null;
  }

  return (
    <MainDialog
      isOpen={true}
      isLoading={currentDialog.isLoading}
      header={{
        title: '',
        ...currentDialog.header,
        onBack: hasBackHistory
          ? sharedDialog.back
          : currentDialog.header?.onBack,
        onClose: sharedDialog.closeAll,
      }}
      footer={currentDialog.footer}
      sx={currentDialog.sx}
    >
      {currentDialog.content}
    </MainDialog>
  );
}
